<template>  
  <div style="height:tbHeight">
    <div class="row">
        <div class="col pb-2 ">
          <el-table
            :data="sellorderProduct.sellOrderSizeList"    
            @current-change="onRowSelectHandler"
            highlight-current-row
            :height="tbHeight/2"
          >      
            <el-table-column sortable label="ขนาด" prop="name"  width="170">
              <template #default="scope">   

                  <span class="text-primary fw-bold">{{ scope.row.name }} </span>    
              </template>
            </el-table-column>
            <el-table-column sortable
              label="Stock"
              align="right"
              width="100"
              :prop="checkType?'stockWeight':'stockQuan'">
              <template #default="scope">
                <div v-if="checkType" >{{ numberWithCommas(scope.row.stockWeight, 2) }} </div>
                <div v-else >{{ numberWithCommas(scope.row.stockQuan, 0) }} </div>
              </template>
            </el-table-column>
            <el-table-column sortable
              label="AVG3M"
              width="100"
              align="right"
              :prop="checkType?'last3Month':'qLast3Month'">
              <template #default="scope">            
                <div v-if="checkType" >{{ numberWithCommas(scope.row.last3Month, 2) }}  </div>
                <div v-else >{{ numberWithCommas(scope.row.qLast3Month, 0) }} </div>
              </template>
            </el-table-column>
            <el-table-column sortable
              label="Stock(วัน)"
              align="right"
              width="110"
              :prop="checkType?'stockWeightDay':'stockQuanDay'">
              <!-- <template #default="scope">
                <div v-if="checkType && scope.row.last3Month>0" >{{ numberWithCommas((scope.row.stockWeight/scope.row.last3Month)*30, 0) }} </div>
                <div v-else-if="!checkType && scope.row.qLast3Month>0" >{{ numberWithCommas((scope.row.stockQuan/scope.row.qLast3Month)*30, 0) }} </div>
              </template> -->
              <template #default="scope">      
                <div v-if="scope.row.stockWeightDay != 99999 && scope.row.stockQuanDay != 99999" >      
                  <div v-if="checkType" >{{ numberWithCommas(scope.row.stockWeightDay, 0) }}  </div>
                  <div v-else >{{ numberWithCommas(scope.row.stockQuanDay, 0) }} </div>
                </div>
                <div v-else>
                  <strong class="text-danger">DS</strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column sortable
              label="TM"
              align="right"
              :prop="checkType?'thisMonth':'qThisMonth'">
              <template #default="scope">
                <div v-if="checkType" >{{ numberWithCommas(scope.row.thisMonth, 2) }} </div>
                <div v-else >{{ numberWithCommas(scope.row.qThisMonth, 0) }} </div>
              </template>
            </el-table-column>
            <el-table-column sortable
                label="LM"
                align="right"
                :prop="checkType?'lastMonth':'qLastMonth'">
                <template #default="scope">
                  <div v-if="checkType" >{{ numberWithCommas(scope.row.lastMonth, 2) }} </div>
                  <div v-else >{{ numberWithCommas(scope.row.qLastMonth, 0) }} </div>
                </template>
            </el-table-column>
            <el-table-column sortable
              label="L2M"
              align="right"
              :prop="checkType?'last2Month':'qLast2Month'">
              <template #default="scope">            
                <div v-if="checkType" >{{ numberWithCommas(scope.row.last2Month, 2) }}  </div>
                <div v-else >{{ numberWithCommas(scope.row.qLast2Month, 0) }} </div>
              </template>
            </el-table-column>
           
            <el-table-column sortable v-if="thisMonth>1"
              label="TY"
              align="right"
              :prop="checkType?'thisYear':'qThisYear'">
              <template #default="scope">            
                <div v-if="checkType" >{{ numberWithCommas(scope.row.thisYear, 2) }}  </div>
                <div v-else >{{ numberWithCommas(scope.row.qThisYear, 0) }} </div>
              </template>
            </el-table-column>
            <el-table-column sortable v-else
              label="LY"
              align="right"
              :prop="checkType?'lastYear':'qLastYear'">
              <template #default="scope">            
                <div v-if="checkType" >{{ numberWithCommas(scope.row.lastYear, 2) }}  </div>
                <div v-else >{{ numberWithCommas(scope.row.qLastYear, 0) }} </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="L2Y"
              align="right"
              :prop="checkType?'last2Year':'qLast2Year'">
              <template #default="scope">            
                <div v-if="checkType" >{{ numberWithCommas(scope.row.last2Year, 2) }}  </div>
                <div v-else >{{ numberWithCommas(scope.row.qLast2Year, 2) }} </div>
              </template>
            </el-table-column>
            <el-table-column
              label="L3Y"
              align="right"
              :prop="checkType?'last3Year':'qLast3Year'">
              <template #default="scope">            
                <div v-if="checkType" >{{ numberWithCommas(scope.row.last3Year, 2) }}  </div>
                <div v-else >{{ numberWithCommas(scope.row.qLast3Year, 2) }} </div>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
      <!-- <br/> -->
      <div class="row">
        <div class="col">
          <el-table
            :data="filterProductList"    
            highlight-current-row
            :height="tbHeight/2"
          >      
            <el-table-column sortable label="สินค้า" prop="name"  width="170">
              <template #default="scope">     
                  <span class="text-primary fw-bold">{{ scope.row.name }} </span>    
              </template>
            </el-table-column>
            <el-table-column sortable
              label="Stock"
              align="right"
              width="100"
              :prop="checkType?'stockWeight':'stockQuan'">
              <template #default="scope">
                <div v-if="checkType" >{{ numberWithCommas(scope.row.stockWeight, 2) }} </div>
                <div v-else >{{ numberWithCommas(scope.row.stockQuan, 0) }} </div>
              </template>
            </el-table-column>
            <el-table-column sortable
              label="AVG3M"
              align="right"
              width="100"
              :prop="checkType?'last3Month':'qLast3Month'">
              <template #default="scope">            
                <div v-if="checkType" >{{ numberWithCommas(scope.row.last3Month, 2) }}  </div>
                <div v-else >{{ numberWithCommas(scope.row.qLast3Month, 0) }} </div>
              </template>
            </el-table-column>
            <el-table-column sortable
              label="Stock(วัน)"
              align="right"
              width="110"
              :prop="checkType?'stockWeightDay':'stockQuanDay'">
              <!-- <template #default="scope">
                <div v-if="checkType && scope.row.last3Month>0" >{{ numberWithCommas((scope.row.stockWeight/scope.row.last3Month)*30, 0) }} </div>
                <div v-else-if="!checkType && scope.row.qLast3Month>0" >{{ numberWithCommas((scope.row.stockQuan/scope.row.qLast3Month)*30, 0) }} </div>
              </template> -->
              <template #default="scope">      
                <div v-if="scope.row.stockWeightDay != 99999 && scope.row.stockQuanDay != 99999" >      
                  <div v-if="checkType" >{{ numberWithCommas(scope.row.stockWeightDay, 0) }}  </div>
                  <div v-else >{{ numberWithCommas(scope.row.stockQuanDay, 0) }} </div>
                </div>
                <div v-else>
                  <strong class="text-danger">DS</strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column sortable
              label="TM"
              align="right"
              :prop="checkType?'thisMonth':'qThisMonth'">
              <template #default="scope">
                <div v-if="checkType" >{{ numberWithCommas(scope.row.thisMonth, 2) }} </div>
                <div v-else >{{ numberWithCommas(scope.row.qThisMonth, 0) }} </div>
              </template>
            </el-table-column>
            <el-table-column sortable
                label="LM"
                align="right"
                :prop="checkType?'lastMonth':'qLastMonth'">
                <template #default="scope">
                  <div v-if="checkType" >{{ numberWithCommas(scope.row.lastMonth, 2) }} </div>
                  <div v-else >{{ numberWithCommas(scope.row.qLastMonth, 0) }} </div>
                </template>
            </el-table-column>
            <el-table-column sortable
              label="L2M"
              align="right"
              :prop="checkType?'last2Month':'qLast2Month'">
              <template #default="scope">            
                <div v-if="checkType" >{{ numberWithCommas(scope.row.last2Month, 2) }}  </div>
                <div v-else >{{ numberWithCommas(scope.row.qLast2Month, 0) }} </div>
              </template>
            </el-table-column>
            
            <el-table-column sortable
              label="TY"
              align="right"
              :prop="checkType?'thisYear':'qThisYear'" v-if="thisMonth>1">
              <template #default="scope">            
                <div v-if="checkType" >{{ numberWithCommas(scope.row.thisYear, 2) }}  </div>
                <div v-else >{{ numberWithCommas(scope.row.qThisYear, 0) }} </div>
              </template>
            </el-table-column>
            <el-table-column sortable v-else
              label="LY"
              align="right"
              :prop="checkType?'lastYear':'qLastYear'">
              <template #default="scope">            
                <div v-if="checkType" >{{ numberWithCommas(scope.row.lastYear, 2) }}  </div>
                <div v-else >{{ numberWithCommas(scope.row.qLastYear, 0) }} </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="L2Y"
              align="right"
              :prop="checkType?'last2Year':'qLast2Year'">
              <template #default="scope">            
                <div v-if="checkType" >{{ numberWithCommas(scope.row.last2Year, 2) }}  </div>
                <div v-else >{{ numberWithCommas(scope.row.qLast2Year, 2) }} </div>
              </template>
            </el-table-column>
            <el-table-column
              label="L3Y"
              align="right"
              :prop="checkType?'last3Year':'qLast3Year'">
              <template #default="scope">            
                <div v-if="checkType" >{{ numberWithCommas(scope.row.last3Year, 2) }}  </div>
                <div v-else >{{ numberWithCommas(scope.row.qLast3Year, 2) }} </div>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>   

</template>

<script>


import ApiService from "@/core/services/ApiService";
import { numberWithCommas, formatDateFromISO, formatDateThDate } from "@/utils";
export default {
  props: {
    // data: Array,
    // category:String,
    sellorderProduct:Object,
    selected: String,
    height: Number,
    checkType:Boolean
  },  
  data(){
      return{
          sellOrderBySizeList:[],
          sellOrderByProductList:[],
          selectSizeID:null         
      }
  },
  computed: {
    windowHeight() {
      return this.$store.getters.getWindowHeight
    },
    tbHeight() {
      return this.height ? this.height : (this.windowHeight - 150)
    },
    filterProductList() {
      return this.sellorderProduct && this.sellorderProduct.sellOrderProductList ? (this.sellorderProduct.sellOrderProductList).filter( (data) => !this.selectSizeID  ||data.productSize == this.selectSizeID ) : this.sellorderProduct.sellOrderProductList
    },
    thisMonth(){
        var date = new Date()
      return date.getMonth()+1;
    },
  },
  methods: {
    numberWithCommas,
    
    summaryBySize({columns, data}) {
      const sums = [];
      columns.forEach((col, index) => {     
        var sumColumns = [];
        if(index === 0) {
          sums[index] = 'เฉลี่ย';
        }
        if(this.checkType){
            sumColumns = ['thisMonth', 'lastMonth','last2Month','thisYear','lastYear']
        }else{
            sumColumns =  ['qThisMonth', 'qLastMonth','qLast2Month','qThisYear','qLastYear']
        }
        
        if(sumColumns.includes(col.property)) {
          sums[index] = numberWithCommas(data.reduce(
            (prev, curr) => {
              return prev + curr[col.property]
            },
            0
          ))
        }
      })      
      return sums;
    },
    summaryByProduct({columns, data}) {
      const sums = [];
      columns.forEach((col, index) => {     
        var sumColumns = [];
        if(index === 0) {
          sums[index] = 'เฉลี่ย';
        }
        if(this.checkType){
            sumColumns = ['thisMonth', 'lastMonth','last2Month','thisYear','lastYear']
        }else{
            sumColumns =  ['qThisMonth', 'qLastMonth','qLast2Month','qThisYear','qLastYear']
        }
        
        if(sumColumns.includes(col.property)) {
          sums[index] = numberWithCommas(data.reduce(
            (prev, curr) => {
              return prev + curr[col.property]

            },
            0
          ))
        }
      })      
      return sums;
    },
   
   
    onRowSelectHandler(selection) {
      // console.log(selection)
      if(selection)
      this.selectSizeID = selection.id;
      // (sellorderProduct.sellOrderProductList).filter( (data) => !selectSizeID  ||data.productSize == selectSizeID )
    },
  },
}

</script>



<style>
  .el-table {
      font-size: 13px;
  }
</style>